/**
 * Décision 423 (TL, 31/10) — le mode hors ligne de l'accueil est masqué à
 * l'écran : ni lien « Ouvrir l'accueil hors ligne », ni bandeau du coffre,
 * ni titre « Hors ligne ». Pendant une coupure, l'agent ne voit que
 * « Connexion perdue — reconnexion en cours » (décision 416) ; le recours
 * reste la feuille papier, ressaisie ensuite.
 *
 * Le code reste en place — coffre chiffré, synchronisation, page
 * `/hors-ligne`, ressaisie — et rien ne change au serveur : rendre `true`
 * suffit à tout rafficher. Une constante d'écran plutôt qu'un interrupteur
 * de Configuration : ceux-ci sont servis par l'API, qui ne doit pas bouger.
 */
export function accueilHorsLigneVisible(): boolean {
  return false
}
